import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AADAuthenticationService } from './aadauthentication.service';
import { Router } from '@angular/router';
import { EnvironmentService } from './environment.service';
import { AlertService } from '../components/app-alert';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(
    private auth: AADAuthenticationService,
    private router: Router,
    private environment: EnvironmentService,
    private alert: AlertService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      setHeaders: {
        Environment: this.environment.environment
      }
    });
    
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
              console.log('event--->>>', event);
          }
          return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log('error--->>>', error);
        switch (error.status) {
          case 401:
            this.alert.clear();
            this.alert.error("You have no permission to perform this action");
            return (new Observable<HttpEvent<unknown>>(observer => {
              observer.complete();
            }));
          case 440:
            this.alert.clear();
            this.alert.error("Your session has expired. Please log in");
            this.auth.logout(() => this.router.navigate(['login']));
            return (new Observable<HttpEvent<unknown>>(observer => {
              observer.complete();
            }));
        }
        return throwError(error);
      }));
  }
}
